import i18next from "i18next";
import { useSelector } from "react-redux";
import OrderRouteItemComponent from "../OrderRouteItemComponent";
import { BlockTitle, RoutesWrapper, Wrapper } from "./style";

const OrderFlightInfoComponent = () => {
  const { t } = i18next;
  const { orderData: { routes } } = useSelector(state => state.order);

  return (
    <Wrapper>
      <BlockTitle>{t("flight_overview")}</BlockTitle>
      <RoutesWrapper>
        {routes.map((route, index) => (
          <OrderRouteItemComponent key={index} route={route} />
        ))}
      </RoutesWrapper>
    </Wrapper>
  )
};

export default OrderFlightInfoComponent;
